
import { ComponentsRegistry } from './ComponentsRegistry';

export default new ComponentsRegistry();



// WEBPACK FOOTER //
// ./uikit/components/index.js